import { useEffect, useState } from 'react';
import type { ShopSettings } from '@cracked-mug/shared';
import { fetchSettings } from '../services/settingsApi';

export function useSettings(): {
  settings: ShopSettings | null;
  isLoading: boolean;
  error: string | null;
} {
  const [settings, setSettings] = useState<ShopSettings | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchSettings()
      .then((s) => {
        if (cancelled) return;
        setSettings(s);
        setError(null);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Failed to load shop settings');
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, isLoading, error };
}
